import FormField from './form_field';

export default class DocumentFormField extends FormField {
	_templateId;

	constructor(fieldProps = {}) {
		super(fieldProps);
	}

	get templateId() {
		return this._templateId;
	}

	set templateId(value) {
		this._templateId = value;
	}
}
